getBillingInfo = ->
  $creditCardMessage = $('[data-cc-info-url]')
  # If creditCardMessage isn't present, they don't have any existing billing info
  return false unless $creditCardMessage.length
  url = $creditCardMessage.attr('data-cc-info-url')
  template = $('#creditCardDisplay').html()
  $.get url, (data) ->
    $creditCardMessage.prepend(
      # using jQuery's merge function (extend)
      PT.Utils.Template('shared/payment_credit_card_info', data)
    )

$ ->
  # fire off the payment js
  if $('.menu-section#payment').length
    require 'utilities/template.coffee'
    getBillingInfo()
